export default "__VITE_ASSET__RLOGENfg__"